// Все интеграции и сервисы в одном файле
export const INTEGRATIONS = {
  // === АНАЛИТИКА ===
  YANDEX_METRICA: {
    COUNTER_ID: 89659454,
    ENABLED: true,
    CONFIG: {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true
    }
  },

  GOOGLE_ANALYTICS: {
    MEASUREMENT_ID: 'G-BEX261BEGB',
    ENABLED: true,
  },

  // === СОЦИАЛЬНЫЕ СЕТИ И МЕССЕНДЖЕРЫ ===
  VK: {
    ACCESS_TOKEN: 'vk1.a.OmIj1SB60t-wC1iPmLzHcSnU57T-HvvKcILZteY-KaLN9Qvvem9qoLFVrKBk-Q2ODE8V5D_toOk6KYhYBKt6mMt14yIry3Z73cWsLwBHfNAuNTFEf4W8aM-FOZVOBt_rQx1mH3L4iYXU7p57B4jeqX0Hogqw3KQdsBBGcH72yZfVgiZqLj9Ir67tPL9FIPJSslapq0MqCd6OtKksToypqQ',
    API_VERSION: '5.131',
    GROUP_ID: '214021218',
    USER_IDS: ['148508206', '181883971'], // ID пользователей для личных сообщений
    BASE_URL: 'https://api.vk.com/method',
    ENABLED: true // ВК уже работает через PHP на сервере
  },

  TELEGRAM: {
    BOT_TOKEN: 'YOUR_BOT_TOKEN', // Получить у @BotFather
    CHAT_ID: 'YOUR_CHAT_ID', // ID чата для уведомлений
    ENABLED: false
  },

  WHATSAPP_BUSINESS: {
    ACCESS_TOKEN: 'YOUR_WHATSAPP_TOKEN',
    PHONE_NUMBER_ID: 'YOUR_PHONE_NUMBER_ID',
    ENABLED: false
  },

  // === EMAIL И ПОЧТА ===
  EMAIL: {
    SMTP: {
      HOST: 'host.first-server.net',
      PORT: 465,
      SECURE: true, // SSL
      USERNAME: 'info@w-wagner.art',
      PASSWORD: 'vM0cQ6vJ9j'
    },
    EMAILJS: {
      SERVICE_ID: 'service_wagner_art', // Заменить на реальный
      TEMPLATE_ID: 'template_contact_form', // Заменить на реальный
      PUBLIC_KEY: 'user_WagnerArtGallery' // Заменить на реальный
    },
    ENABLED: true // Включено - работает через PHP на хостинге
  },

  // === МАРКЕТИНГ И РЕКЛАМА ===
  FACEBOOK_PIXEL: {
    PIXEL_ID: 'YOUR_PIXEL_ID',
    ENABLED: false
  },

  GOOGLE_ADS: {
    CONVERSION_ID: 'AW-XXXXXXXXX',
    ENABLED: false
  },

  YANDEX_DIRECT: {
    COUNTER_ID: 'YOUR_COUNTER_ID',
    ENABLED: false
  },

  // === ЧАТЫ И ПОДДЕРЖКА ===
  JIVOSITE: {
    WIDGET_ID: 'YOUR_WIDGET_ID',
    ENABLED: false
  },

  TAWK_TO: {
    PROPERTY_ID: 'YOUR_PROPERTY_ID',
    WIDGET_ID: 'YOUR_WIDGET_ID',
    ENABLED: false
  },

  // === КАРТЫ ===
  YANDEX_MAPS: {
    API_KEY: 'YOUR_YANDEX_MAPS_KEY',
    CENTER: [55.0084, 73.2986], // Омск
    ZOOM: 12,
    ENABLED: false
  },

  GOOGLE_MAPS: {
    API_KEY: 'YOUR_GOOGLE_MAPS_KEY',
    ENABLED: false
  },

  // === ПЛАТЕЖИ ===
  STRIPE: {
    PUBLISHABLE_KEY: 'pk_test_...',
    ENABLED: false
  },

  ROBOKASSA: {
    SHOP_ID: 'YOUR_SHOP_ID',
    ENABLED: false
  },

  YANDEX_KASSA: {
    SHOP_ID: 'YOUR_SHOP_ID',
    SECRET_KEY: 'YOUR_SECRET_KEY',
    ENABLED: false
  },

  // === SEO И ИНДЕКСАЦИЯ ===
  GOOGLE_SEARCH_CONSOLE: {
    VERIFICATION_CODE: 'VERIFIED', // Аккаунт уже подтвержден
    ENABLED: true
  },

  YANDEX_WEBMASTER: {
    VERIFICATION_CODE: 'VERIFIED', // Аккаунт уже подтвержден
    ENABLED: true
  },

  // === ЯНДЕКС.БИЗНЕС ===
  YANDEX_BUSINESS: {
    ORGANIZATION_ID: '16980380055',
    SUBSCRIPTION_IDS: ['32923317', '50793954'],
    ENABLED: true
  },

  // === ФАЙЛЫ И CDN ===
  CLOUDINARY: {
    CLOUD_NAME: 'YOUR_CLOUD_NAME',
    API_KEY: 'YOUR_API_KEY',
    ENABLED: false
  },

  // === PUSH-УВЕДОМЛЕНИЯ ===
  ONESIGNAL: {
    APP_ID: 'YOUR_APP_ID',
    ENABLED: false
  },

  // === A/B ТЕСТИРОВАНИЕ ===
  GOOGLE_OPTIMIZE: {
    CONTAINER_ID: 'GTM-XXXXXXX',
    ENABLED: false
  }
};

// === ТИПЫ ДЛЯ ФОРМ ===
export interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  message: string;
}

export interface VKMessageData extends ContactFormData {}

// === ФУНКЦИИ ИНИЦИАЛИЗАЦИИ ===
export const initYandexMetrica = () => {
  if (!INTEGRATIONS.YANDEX_METRICA.ENABLED) return;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.innerHTML = `
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    ym(${INTEGRATIONS.YANDEX_METRICA.COUNTER_ID}, "init", ${JSON.stringify(INTEGRATIONS.YANDEX_METRICA.CONFIG)});
  `;
  document.head.appendChild(script);

  // Noscript fallback
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${INTEGRATIONS.YANDEX_METRICA.COUNTER_ID}" style="position:absolute; left:-9999px;" alt="" /></div>`;
  document.body.appendChild(noscript);
};

export const initGoogleAnalytics = () => {
  if (!INTEGRATIONS.GOOGLE_ANALYTICS.ENABLED) return;

  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${INTEGRATIONS.GOOGLE_ANALYTICS.MEASUREMENT_ID}`;
  document.head.appendChild(gtagScript);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer?.push(args);
  }
  (window as any).gtag = gtag;
  gtag('js', new Date());
  gtag('config', INTEGRATIONS.GOOGLE_ANALYTICS.MEASUREMENT_ID);
};

export const initFacebookPixel = () => {
  if (!INTEGRATIONS.FACEBOOK_PIXEL.ENABLED) return;

  const script = document.createElement('script');
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${INTEGRATIONS.FACEBOOK_PIXEL.PIXEL_ID}');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(script);
};

// Инициализация всех активных интеграций
export const initAllIntegrations = () => {
  initYandexMetrica();
  initGoogleAnalytics();
  initFacebookPixel();
  
  console.log('🚀 Все активные интеграции инициализированы');
};

// === ПОЛЕЗНЫЕ ФУНКЦИИ ===
export const trackEvent = (eventName: string, params?: any) => {
  // Яндекс.Метрика
  if (INTEGRATIONS.YANDEX_METRICA.ENABLED && (window as any).ym) {
    (window as any).ym(INTEGRATIONS.YANDEX_METRICA.COUNTER_ID, 'reachGoal', eventName, params);
  }
  
  // Google Analytics
  if (INTEGRATIONS.GOOGLE_ANALYTICS.ENABLED && (window as any).gtag) {
    (window as any).gtag('event', eventName, params);
  }
};

export const trackPurchase = (value: number, currency: string = 'RUB') => {
  trackEvent('purchase', { value, currency });
};

export const trackFormSubmit = (formName: string) => {
  trackEvent('form_submit', { form_name: formName });
};

// Глобальные типы
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    ym?: (...args: any[]) => void;
    dataLayer?: any[];
    fbq?: (...args: any[]) => void;
  }
}